import HeaderBar from "../../../../components/header/headerBar";
import MainButton from "../../../../components/button/mainButton";
import IconMdi from "@mdi/react";
import {
  mdiPlusCircle,
  mdiMenuRight,
  mdiMenuLeft,
  mdiTrashCanOutline,
  mdiMagnify,
} from "@mdi/js";
import EmptyModel from "../../../../components/modal/emptyModal";
import React, { useState, useEffect } from "react";
import { SearchField } from "../../../../components/textfield";
import "../../../../assets/styles/admin/treatment.scss";
import { useHistory } from "react-router";
import axios from "axios";
import { useParams } from "react-router-dom";
import { numberWithCommas } from "../../../../helpers/functions.js";

import {
  Select,
  Input,
  Form,
  Checkbox,
  Radio,
  Button,
  Modal,
  Table,
  message,
  InputNumber,
  Row,
  Col,
  Space,
} from "antd";
import { NONAME } from "dns";
import { any } from "prop-types";

const TreatmentCreate = () => {
  const { confirm } = Modal;
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [selectBranch, setSelectBranch] = useState<any>([]);
  const [Category, setCategory] = useState<any>([]);
  const [SubCategory, setSubCategory] = useState<any>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [treatmentUnit, setTreatmentUnit] = useState<any>([]);
  const [cycleOfUse, setCycleOfUse] = useState<any>([]);
  const [equipment, setEquipment] = useState<any>([]);

  const [bomStork, setBomstrok] = useState<any>([]);
  const [useBom, setUseBom] = useState<any>([]);
  const [totalBom, setTotalBom] = useState<any>(0);
  const [searchBom, setSearchBom] = useState<string>("");

  const [checkNormal, setCheckNormal] = useState<boolean>(false);
  const [checkSpecial, setCheckSpecial] = useState<boolean>(false);
  const [checkBom, setCheckBom] = useState<boolean>(false);

  const [getEditcycleOfUse2, setgetEditcycleOfUse2] = useState<string>("");
  const [getEditEquipment2, setgetEditEquipment2] = useState<string>("");

  const [disabledNumberCourse, setDisabledNumberCourse] =
    useState<boolean>(false);

  const { Option } = Select;
  const { TextArea } = Input;
  const [form] = Form.useForm();

  const { id }: any = useParams();

  const columns = [
    {
      title: "",
      dataIndex: "no",
    },
    {
      title: "Code",
      dataIndex: "code",
    },
    {
      title: "Item",
      dataIndex: "item",
    },
    {
      title: "Price/Unit",
      dataIndex: "price",
    },
    {
      title: "Quantity",
      render: (record: any) => (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            onClick={() => reduceQuantity(record.indexNum)}
            style={{ cursor: "pointer" }}
          >
            <IconMdi path={mdiMenuLeft} size="24" />
          </div>
          <div>{record.quantity}</div>
          <div
            onClick={() => addQuantity(record.indexNum)}
            style={{ cursor: "pointer" }}
          >
            <IconMdi path={mdiMenuRight} size="24" />
          </div>
        </div>
      ),
    },
    {
      title: "Unit",
      dataIndex: "unit",
    },
    {
      title: "Total",
      render: (record: any) => (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {record.total}
        </div>
      ),
    },
    {
      title: "",
      render: (record: any) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            color: "#FF6760",
            cursor: "pointer",
          }}
          onClick={() => removeBom(record.indexNum, record._id)}
        >
          <IconMdi path={mdiTrashCanOutline} size="24" />
        </div>
      ),
    },
  ];

  const columnStork = [
    {
      title: "",
      dataIndex: "no",
    },
    {
      title: "Code",
      dataIndex: "code",
    },
    {
      title: "Item",
      dataIndex: "item",
    },
    {
      title: "Unit",
      dataIndex: "unit",
    },
    {
      title: "Price/Unit",
      dataIndex: "price",
    },
    {
      title: "Select",
      render: (record: any) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            cursor: "pointer",
            pointerEvents: record.isSelect === true ? "auto" : "none",
          }}
          onClick={() => addBom(record)}
        >
          <IconMdi
            path={mdiPlusCircle}
            size="24"
            color={record.isSelect === true ? "#4D7E7F" : "#D3D8DD  "}
          />
        </div>
      ),
    },
  ];

  function onClose() {
    setIsOpen(false);
  }

  const getAPIs = async () => {
    const getBranch = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/branches?page=1`
    );
    setSelectBranch(getBranch.data.data);

    const getCategory = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/product-categories?page=1&perPage=20`
    );
    setCategory(getCategory.data.data);

    const getUnit = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/treatment-units`
    );
    setTreatmentUnit(getUnit.data.data);

    const getCycle = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/treatment-cycle-of-uses`
    );
    setCycleOfUse(getCycle?.data?.data);

    const getEquipment = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/medical-equipments?page=1&category=all&branch=all&search=`
    );
    setEquipment(getEquipment?.data?.data);

    // Get Data For Edit ////////////////////////////////////////////////////////////

    let dataBomtt = [];

    if (id !== "create") {
      const getDataEdit = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/treatments/${id}`
      );
      // console.log("getDataEdit", getDataEdit);

      const getEditBranch = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/branches/${getDataEdit?.data?.branch}`
      );

      if (getDataEdit.data.cycleOfUse) {
        await axios
          .get(
            `${process.env.REACT_APP_BASE_URL}/treatment-cycle-of-uses/${getDataEdit?.data?.cycleOfUse}`
          )
          .then((res) => {
            console.log("getDataEdit", res?.data);

            form.setFieldsValue({ cycleOfUse: res?.data?._id });
          });
      }

      if (getDataEdit.data.equipments) {
        form.setFieldsValue({ equipments: getDataEdit.data.equipments });
        // await axios
        //   .get(
        //     `${process.env.REACT_APP_BASE_URL}/medical-equipments/${getDataEdit?.data?.equipments}`
        //   )
        //   .then((res) => {
        //     // console.log("mdical", res.data);
        //     // form.setFieldsValue({ equipments: res.data });
        //   });
      }

      selectCategory(getDataEdit?.data?.productCategory);

      form.setFieldsValue({ branch: getEditBranch.data?.data?._id });
      form.setFieldsValue({
        productCategory: getDataEdit?.data?.productCategory,
      });
      form.setFieldsValue({
        productSubCategory: getDataEdit.data?.productSubCategory,
      });
      form.setFieldsValue({ code: getDataEdit?.data?.code });
      form.setFieldsValue({ name: getDataEdit.data?.name });
      form.setFieldsValue({ treatmentUnit: getDataEdit.data?.treatmentUnit });
      form.setFieldsValue({
        isCommissionSales: getDataEdit.data?.isCommissionSales,
      });
      form.setFieldsValue({
        isCommissionDoctor: getDataEdit.data?.isCommissionDoctor,
      });

      form.setFieldsValue({ Active: getDataEdit.data?.isActive });
      form.setFieldsValue({ Vat: getDataEdit.data?.isVat });
      form.setFieldsValue({
        otherType: getDataEdit.data?.otherType || "normal",
      });
      form.setFieldsValue({ sc: getDataEdit.data?.sc });

      if (getDataEdit.data.sc === "s") {
        setDisabledNumberCourse(true);
      }

      form.setFieldsValue({ number: getDataEdit?.data?.number });
      console.log("getEdit", getEditcycleOfUse2);

      form.setFieldsValue({ details: getDataEdit.data?.detail });

      if (getDataEdit.data?.price?.normal) {
        form.setFieldsValue({ normal: true });
        form.setFieldsValue({
          NormalPriceLocal: getDataEdit.data.price.normal.coursePriceLocal,
        });
        form.setFieldsValue({
          NormalPriceAgency: getDataEdit.data.price.normal.coursePriceAgency,
        });
        form.setFieldsValue({
          NormalDiscount: getDataEdit.data.price.normal.maximumDiscount,
        });
        form.setFieldsValue({
          NormalfeeRate1: getDataEdit.data.price.normal.feeRate1,
        });
        form.setFieldsValue({
          NormalfeeRate2: getDataEdit.data.price.normal.feeRate2,
        });
        setCheckNormal(true);
      }

      if (getDataEdit?.data?.price?.special?.coursePriceAgency) {
        form.setFieldsValue({ special: true });
        form.setFieldsValue({
          SpecialPriceLocal: getDataEdit.data.price.special.coursePriceLocal,
        });
        form.setFieldsValue({
          SpecialPriceAgency: getDataEdit.data.price.special.coursePriceAgency,
        });
        form.setFieldsValue({
          SpecialDiscount: getDataEdit.data.price.special.maximumDiscount,
        });
        form.setFieldsValue({
          SpecialfeeRate1: getDataEdit.data.price.special.feeRate1,
        });
        form.setFieldsValue({
          SpecialfeeRate2: getDataEdit.data.price.special.feeRate2,
        });
        setCheckSpecial(true);
      }

      if (getDataEdit?.data?.boms?.length > 0) {
        form.setFieldsValue({ checkBom: true });
        setCheckBom(true);

        for (var i = 0; i < getDataEdit.data.boms.length; i++) {
          const getStork = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/stock-products/${getDataEdit.data.boms[i].stockProduct}`
          );
          const getStorkUnit = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/stock-product-units/${getStork.data.data.unit}`
          );

          const dataStrok = {
            code: getStork.data.data.code,
            item: getStork.data.data.name,
            unit: getStorkUnit.data.name,
            price: getStork.data.data.totalPricePerUnit,
            _id: getStork.data.data._id,
            quantity: getDataEdit.data.boms[i].quantity,
          };
          dataBomtt.push(dataStrok);
        }
      }

      if (dataBomtt) {
        dataBomtt = dataBomtt.map((dataBomtt: any, index: number) => ({
          ...dataBomtt,
          no: index + 1,
          total: dataBomtt.price * dataBomtt.quantity,
          indexNum: index,
        }));
        setUseBom(dataBomtt);
        const lastTotal = dataBomtt.reduce(
          (a: any, v: any) => (a = a + v.total),
          0
        );
        setTotalBom(lastTotal);
      }
    }
  };

  const getStorkAdd = async (text: any) => {
    console.log("search= ", text);
    setSearchBom("");
    let newOrder = [];
    const getStork = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/stock-products?page=1&category=all&search=${text}`
    );

    for (var i = 0; i < getStork.data.data.length; i++) {
      const getStorkUnit = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/stock-product-units/${getStork.data.data[i].unit}`
      );
      const dataStrok = {
        code: getStork.data.data[i].code,
        item: getStork.data.data[i].name,
        unit: getStorkUnit.data.name,
        price: getStork.data.data[i].totalPricePerUnit,
        _id: getStork.data.data[i]._id,
        isSelect: true,
        no: i + 1,
        quantity: 1,
      };
      newOrder.push(dataStrok);
    }
    const newStork = newOrder.filter((itemA) => {
      return !useBom.find((itemB: any) => {
        return itemA._id === itemB._id;
      });
    });

    setBomstrok(newStork);
  };

  const selectCategory = async (value: any) => {
    form.setFieldsValue({ productSubCategory: null });
    const getSubCategory = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/product-sub-categories/category/${value}?page=1&perPage=20`
    );
    // const getCode = await axios.get(
    //   `${process.env.REACT_APP_BASE_URL}//treatments/get-code?productCategory=${value}`
    // );
    // form.setFieldsValue({ code: getCode.data.code });

    setSubCategory(getSubCategory.data.data);
  };

  const selectSubCategory = async (value: any) => {
    console.log(value);
    const getCode = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/treatments/get-code?subProductCategory=${value}`
    );
    form.setFieldsValue({ code: getCode.data.code });
  };

  const showModal = () => {
    setIsModalVisible(true);
    getStorkAdd("");
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onFinish = async (values: any) => {
    let dataBom = [];

    for (var i = 0; i < useBom.length; i++) {
      const dataArray = {
        stockProduct: useBom[i]._id,
        quantity: useBom[i].quantity,
      };
      dataBom.push(dataArray);
    }

    console.log("values", values);

    const body = {
      code: values?.code,
      branch: values?.branch,
      productCategory: values?.productCategory,
      productSubCategory: values?.productSubCategory,
      name: values?.name,
      treatmentUnit: values?.treatmentUnit,
      isCommissionSales: values?.isCommissionSales,
      isCommissionDoctor: values?.isCommissionDoctor,
      isActive: values?.Active,
      isVat: values?.Vat,
      otherType: values?.otherType,
      sc: values?.sc,
      number: values?.number,
      cycleOfUse: values?.cycleOfUse,
      equipments: values?.equipments,
      detail: values?.details,
      price: {
        normal: {
          coursePriceLocal: values?.NormalPriceLocal,
          coursePriceAgency: values?.NormalPriceAgency,
          maximumDiscount: values?.NormalDiscount,
          feeRate1: values?.NormalfeeRate1,
          feeRate2: values?.NormalfeeRate2,
        },
        special: {
          coursePriceLocal: values?.SpecialPriceLocal,
          coursePriceAgency: values?.SpecialPriceAgency,
          maximumDiscount: values?.SpecialDiscount,
          feeRate1: values?.SpecialfeeRate1,
          feeRate2: values?.SpecialfeeRate2,
        },
      },
      isBom: checkBom,
      boms: dataBom,
      totalCostOfComponents: totalBom,
    };
    console.log(body);
    // return;
    try {
      if (id === "create") {
        await axios.post(`${process.env.REACT_APP_BASE_URL}/treatments`, body);
        setTimeout(() => {
          message.success("Create Success");
          history.push(`/setting/service/treatment`);
        }, 1000);
      } else {
        await axios.patch(
          `${process.env.REACT_APP_BASE_URL}/treatments/${id}`,
          body
        );
      }
      history.push(`/setting/service/treatment`);
    } catch (err) {
      console.log(err);
      return;
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const addBom = (value: any) => {
    let newBom = [...useBom];

    newBom.push(value);
    for (var i = 0; i < bomStork.length; i++) {
      if (bomStork[i]._id === value._id) {
        bomStork[i].isSelect = false;
      }
    }
    if (newBom) {
      newBom = newBom.map((newBom: any, index: number) => ({
        ...newBom,
        indexNum: index,
        no: index + 1,
        total: newBom.price * newBom.quantity,
      }));
      const lastTotal = newBom.reduce((a: any, v: any) => (a = a + v.total), 0);
      setTotalBom(lastTotal);
      setUseBom(newBom);
    }
    handleCancel();
  };

  const addQuantity = (index: any) => {
    let newValue = [...useBom];
    newValue[index].quantity = newValue[index].quantity + 1;
    newValue[index].total = newValue[index].price * newValue[index].quantity;
    setUseBom(newValue);
    isTotalBom();
  };

  const reduceQuantity = (index: any) => {
    let newValue = [...useBom];
    if (newValue[index].quantity > 1) {
      newValue[index].quantity = newValue[index].quantity - 1;
      newValue[index].total = newValue[index].price * newValue[index].quantity;
      setUseBom(newValue);
      isTotalBom();
    }
  };

  const removeBom = (index: any, id: any) => {
    let newValue = [...useBom];
    for (var i = 0; i < bomStork.length; i++) {
      if (bomStork[i]._id === id) {
        bomStork[i].isSelect = true;
      }
    }
    newValue.splice(index, 1);
    if (newValue) {
      newValue = newValue.map((newBom: any, index: number) => ({
        ...newBom,
        indexNum: index,
      }));
      const lastTotal = newValue.reduce(
        (a: any, v: any) => (a = a + v.total),
        0
      );
      setTotalBom(lastTotal);
      setUseBom(newValue);
    }
  };

  const isTotalBom = () => {
    const lastTotal = useBom.reduce((a: any, v: any) => (a = a + v.total), 0);
    setTotalBom(lastTotal);
  };
  const onchangeSc = (type: any) => {
    console.log("type", type.target.value);

    if (type.target.value === "s") {
      setDisabledNumberCourse(true);
      form.setFieldsValue({ number: 1 });
    } else if (type.target.value === "c") {
      setDisabledNumberCourse(false);
      form.setFieldsValue({ number: "" });
    }
  };

  useEffect(() => {
    getAPIs();
  }, []);

  return (
    <div>
      <HeaderBar
        title={id === "create" ? "TREATMENT / CREATE" : "TREATMENT / UPDATE"}
        btnBack={true}
      />
      <div style={{ padding: "20px 40px" }}>
        <Modal
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          width={800}
          footer={null}
        >
          <p>เลือกรายการ/Select Item</p>
          <div style={{ position: "relative" }}>
            <Input
              className="input-search"
              value={searchBom}
              onChange={(e: any) => {
                setSearchBom(e.target.value);
              }}
            />
            <div onClick={() => getStorkAdd(searchBom)}>
              <IconMdi
                path={mdiMagnify}
                size="24"
                style={{
                  position: "absolute",
                  top: "15%",
                  right: "2%",
                  cursor: "pointer",
                }}
                color="#5BAEA9"
              />
            </div>
          </div>
          <Table
            columns={columnStork}
            dataSource={bomStork}
            pagination={false}
            bordered
            rowKey={"_id"}
          />
        </Modal>

        <EmptyModel show={isOpen} onClose={onClose} width="50%">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "20px 40px",
            }}
          >
            <h4>เลือกรายการ</h4>

            <div className="row justify-center  mt-20">
              <SearchField placeholder="Search for  Name, Code" color="#fff" />
            </div>
            <div className="row justify-start mt-20">
              <div className="ex3"></div>
            </div>
          </div>
        </EmptyModel>

        <Form
          name="basic"
          initialValues={{ remember: true }}
          autoComplete="off"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
        >
          <div className="create-page">
            <h4 style={{ fontSize: "20px" }}>
              {id === "create" ? "Create" : "Update"} Medical Treatment
            </h4>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 30,
              }}
            >
              <div style={{ width: "30%", marginBottom: 25 }}>
                <div
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  สาขา/Branch
                </div>
                <Form.Item
                  name="branch"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    style={{ width: "100%" }}
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {selectBranch.map((item: any, index: any) => (
                      <Option value={item._id} key={item._id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div style={{ width: "30%", marginBottom: 25 }}>
                <div
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  ประเภทหัตถการ/Treatment Type
                </div>
                <Form.Item
                  name="productCategory"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%" }}
                    onChange={selectCategory}
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                  >
                    {Category.map((item: any, index: any) => (
                      <Option value={item._id} key={item._id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div style={{ width: "30%", marginBottom: 25 }}>
                <div
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  แผนกหัตถการ/Treatment Department
                </div>
                <Form.Item
                  name="productSubCategory"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%" }}
                    onChange={selectSubCategory}
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                  >
                    {SubCategory.map((item: any, index: any) => (
                      <Option value={item._id} key={item._id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ width: "30%" }}>
                <div
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  รหัส/Code
                </div>
                <Form.Item name="code">
                  <Input
                    style={{
                      padding: 0,
                      backgroundColor: "#D3D8DD",
                    }}
                    disabled
                  />
                </Form.Item>
              </div>
              <div style={{ width: "30%" }}>
                <div
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  ชื่อ/Name
                </div>
                <Form.Item
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Input style={{ padding: 0 }} />
                </Form.Item>
              </div>
              <div style={{ width: "30%" }}>
                <div
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  หน่วยที่ใช้/Unit
                </div>
                <Form.Item
                  name="treatmentUnit"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%" }}
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                  >
                    {treatmentUnit.map((item: any, index: any) => (
                      <Option value={item._id} key={item._id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 30,
              }}
            >
              <div
                style={{
                  width: "20%",
                }}
              >
                <div
                  style={{
                    color: "#5BAEA9",
                    fontSize: 14,
                    fontWeight: 500,
                    marginBottom: "10px",
                  }}
                >
                  ประเภทอื่นๆ/Others
                </div>
                <div className="justify-center" style={{ display: "flex" }}>
                  <Form.Item
                    name="otherType"
                    rules={[
                      {
                        required: true,
                        message: "กรุณาเลือก!",
                      },
                    ]}
                  >
                    <Radio.Group onChange={(e: any) => {}}>
                      <Space>
                        <Radio value="normal">Not Other</Radio>
                        <Radio value="other">Other</Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </div>
              </div>
              <Row
                style={{
                  width: "30%",
                  marginTop: "30px",
                  justifyContent: "space-around",
                }}
                justify="center"
              >
                <Col>
                  <Form.Item
                    name="sc"
                    rules={[
                      {
                        required: true,
                        message: "กรุณาเลือก!",
                      },
                    ]}
                  >
                    <Radio.Group onChange={(e: any) => onchangeSc(e)}>
                      <Space>
                        <Radio value="s">Single</Radio>
                        <Radio value="c">Course</Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              <div style={{ width: "30%" }}>
                <div
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  จำนวน/คอร์ส/Number/Course
                </div>
                <Form.Item
                  name="number"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Input
                    style={{
                      padding: 0,
                      backgroundColor:
                        disabledNumberCourse === true ? "#D3D8DD" : "",
                    }}
                    readOnly={disabledNumberCourse}
                    type="number"
                  />
                </Form.Item>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 30,
              }}
            >
              <div
                style={{
                  width: "30%",
                  marginBottom: 25,
                  justifyContent: "space-around",
                }}
              >
                <div
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  รอบวันที่ใช้งาน/Cycle of used
                </div>
                <Form.Item name="cycleOfUse">
                  <Select
                    style={{ width: "100%" }}
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                  >
                    {cycleOfUse.map((item: any, index: any) => (
                      <Option value={item._id} key={item._id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div>
                {/* <div
                  style={{
                    color: "#5BAEA9",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  เครื่องมือที่ใช้/Equipment
                </div> */}
                {/* <Form.Item name="equipment">
                  <Select
                    style={{ width: "100%" }}
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                  >
                    {equipment.map((item: any, index: any) => (
                      <Option value={item._id} key={item._id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item> */}
                <div
                  style={{
                    display: "flex",
                    paddingRight: "130px",
                    marginTop: "26px",
                  }}
                >
                  <div style={{ marginRight: "16px" }}>
                    <Form.Item name="Active" valuePropName="checked">
                      <Checkbox>Active</Checkbox>
                    </Form.Item>
                  </div>
                  <div>
                    <Form.Item name="Vat" valuePropName="checked">
                      <Checkbox>Vat</Checkbox>
                    </Form.Item>
                  </div>
                </div>
              </div>
              <div style={{ width: "30%", marginBottom: 25 }}>
                <div
                  style={{
                    color: "#5BAEA9",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  เครื่องมือที่ใช้/Equipment
                </div>
                <Form.Item name="equipments">
                  <Select
                    style={{ width: "100%" }}
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    mode="multiple"
                  >
                    {equipment.map((item: any, index: any) => (
                      <Option value={item._id} key={item._id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                // marginTop: 30,
              }}
            >
              <div
                style={{
                  width: "20%",
                }}
              >
                <div
                  style={{
                    color: "#5BAEA9",
                    fontSize: 14,
                    fontWeight: 500,
                    marginBottom: "10px",
                  }}
                >
                  ค่าคอมมิชชั่น/Commission
                </div>
                <div className="justify-center" style={{ display: "flex" }}>
                  <Form.Item name="isCommissionDoctor" valuePropName="checked">
                    <Checkbox>Doctors</Checkbox>
                  </Form.Item>
                  <Form.Item name="isCommissionSales" valuePropName="checked">
                    <Checkbox>Sales</Checkbox>
                  </Form.Item>
                </div>
              </div>
            </div>

            <div className="row">
              <label className={`text-area`} htmlFor="text-area">
                <div style={{ marginBottom: "30px" }} className="title-input">
                  รายละเอียด/Detail
                </div>
                <Form.Item name="details">
                  <textarea style={{ resize: "none" }} />
                </Form.Item>
              </label>
            </div>
          </div>

          <div style={{ marginTop: "20px" }}>
            <div className="create-page">
              <h4>ราคา</h4>
              <Form.Item
                name="normal"
                valuePropName="checked"
                rules={[
                  {
                    required: true,
                    message: "เลือก!",
                  },
                ]}
              >
                <Checkbox
                  onChange={() => {
                    setCheckNormal(!checkNormal);
                    setCheckSpecial(false);
                    form.setFieldsValue({ special: false });
                  }}
                >
                  Normal
                </Checkbox>
              </Form.Item>
              {checkNormal === true ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    marginBottom: 35,
                    marginTop: 15,
                  }}
                >
                  <div>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 13,
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      ราคาคอร์ส (Local)
                    </div>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 13,
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      Course Price(Local)
                    </div>
                    <Form.Item
                      name="NormalPriceLocal"
                      rules={[
                        {
                          required: true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <InputNumber
                        className="inputNumber-custom-treatment"
                        min={1}
                        controls={false}
                        step="0.00"
                        type="number"
                        // autoFocus
                      />
                    </Form.Item>
                  </div>
                  <div>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 13,
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      ราคาคอร์ส (Agency)
                    </div>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 13,
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      Course Price (Agency)
                    </div>
                    <Form.Item
                      name="NormalPriceAgency"
                      rules={[
                        {
                          required: true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <InputNumber
                        className="inputNumber-custom-treatment"
                        min={1}
                        controls={false}
                        type="number"
                        step="0.00"
                      />
                    </Form.Item>
                  </div>
                  <div>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 13,
                        fontSize: 14,
                        fontWeight: 500,
                        display: "flex",
                      }}
                    >
                      ส่วนลดสูงสุด <div style={{ color: "#E76464" }}>%</div>
                    </div>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 13,
                        fontSize: 14,
                        fontWeight: 500,
                        display: "flex",
                      }}
                    >
                      Maximum Discount <div style={{ color: "#E76464" }}>%</div>
                    </div>
                    <Form.Item name="NormalDiscount">
                      <InputNumber
                        className="inputNumber-custom-treatment"
                        style={
                          {
                            // boxShadow: "none",
                          }
                        }
                        min={1}
                        max={100}
                        // bordered={false}
                        // defaultValue={50}
                        controls={false}
                        type="number"
                      />
                    </Form.Item>
                  </div>
                  <div>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 47,
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      Therapist Fee Rate 1
                    </div>
                    <Form.Item name="NormalfeeRate1">
                      <InputNumber
                        className="inputNumber-custom-treatment"
                        min={0}
                        controls={false}
                        type="number"
                        step="0.00"
                      />
                    </Form.Item>
                  </div>
                  <div>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 47,
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      Therapist Fee Rate 2
                    </div>
                    <Form.Item name="NormalfeeRate2">
                      <InputNumber
                        className="inputNumber-custom-treatment"
                        min={0}
                        controls={false}
                        type="number"
                        step="0.00"
                      />
                    </Form.Item>
                  </div>
                </div>
              ) : (
                form.setFieldsValue({
                  NormalPriceLocal: "",
                  NormalPriceAgency: "",
                  NormalDiscount: "",
                  NormalfeeRate1: "",
                  NormalfeeRate2: "",
                })
              )}
              <Form.Item name="special" valuePropName="checked">
                <Checkbox onChange={() => setCheckSpecial(!checkSpecial)}>
                  Buffet Special
                </Checkbox>
              </Form.Item>
              {checkSpecial !== false ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    marginTop: 15,
                  }}
                >
                  <div>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 13,
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      ราคาคอร์ส (Local)
                    </div>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 13,
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      Course Price(Local)
                    </div>
                    <Form.Item
                      name="SpecialPriceLocal"
                      rules={[
                        {
                          required: true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <InputNumber
                        className="inputNumber-custom-treatment"
                        min={1}
                        controls={false}
                        type="number"
                        // autoFocus
                        step="0.00"
                      />
                    </Form.Item>
                  </div>
                  <div>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 13,
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      ราคาคอร์ส (Agency)
                    </div>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 13,
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      Course Price (Agency)
                    </div>
                    <Form.Item
                      name="SpecialPriceAgency"
                      rules={[
                        {
                          required: true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <InputNumber
                        className="inputNumber-custom-treatment"
                        min={1}
                        controls={false}
                        type="number"
                        step="0.00"
                      />
                    </Form.Item>
                  </div>
                  <div>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 13,
                        fontSize: 14,
                        fontWeight: 500,
                        display: "flex",
                      }}
                    >
                      ส่วนลดสูงสุด <div style={{ color: "#E76464" }}>%</div>
                    </div>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 13,
                        fontSize: 14,
                        fontWeight: 500,
                        display: "flex",
                      }}
                    >
                      Maximum Discount <div style={{ color: "#E76464" }}>%</div>
                    </div>
                    <Form.Item name="SpecialDiscount">
                      <InputNumber
                        className="inputNumber-custom-treatment"
                        min={1}
                        max={100}
                        controls={false}
                        type="number"
                      />
                    </Form.Item>
                  </div>
                  <div>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 47,
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      Therapist Fee Rate 1
                    </div>
                    <Form.Item name="SpecialfeeRate1">
                      <InputNumber
                        className="inputNumber-custom-treatment"
                        min={0}
                        controls={false}
                        type="number"
                        step="0.00"
                      />
                    </Form.Item>
                  </div>
                  <div>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 47,
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      Therapist Fee Rate 2
                    </div>
                    <Form.Item name="SpecialfeeRate2">
                      <InputNumber
                        className="inputNumber-custom-treatment"
                        min={0}
                        controls={false}
                        type="number"
                        step="0.00"
                      />
                    </Form.Item>
                  </div>
                </div>
              ) : (
                form.setFieldsValue({
                  SpecialPriceLocal: "",
                  SpecialPriceAgency: "",
                  PriceAgency: "",
                  SpecialDiscount: "",
                  SpecialfeeRate1: "",
                  SpecialfeeRate2: "",
                })
              )}
            </div>
          </div>
          <div style={{ marginTop: "20px" }}>
            <div className="create-page" style={{ padding: "20px 40px" }}>
              <div className="row">
                <div
                  className="check-box col-2"
                  style={{ cursor: "pointer", alignItems: "center" }}
                >
                  <Form.Item name="checkBom" valuePropName="checked">
                    <Checkbox onChange={() => setCheckBom(!checkBom)}>
                      Bom
                    </Checkbox>
                  </Form.Item>
                </div>
              </div>
              {checkBom && (
                <div className="email_type">
                  <h3>Create BOM</h3>
                </div>
              )}
              {checkBom && (
                <div className="button-add">
                  <MainButton
                    title="Select Item"
                    onClick={showModal}
                  ></MainButton>
                </div>
              )}
              {checkBom && (
                <div style={{ marginTop: "20px" }}>
                  <Table
                    columns={columns}
                    dataSource={useBom}
                    pagination={false}
                    bordered
                  />
                  <div
                    style={{
                      display: "flex",
                      padding: 14,
                      borderBottom: "1px solid #f0f0f0",
                    }}
                  >
                    <div
                      style={{
                        width: "60%",
                        textAlign: "end",
                        fontWeight: 600,
                        fontSize: 16,
                      }}
                    >
                      รวมราคาทุนส่วนประกอบ/Total cost of components.
                    </div>
                    <div
                      style={{
                        width: "35%",
                        textAlign: "end",
                        fontWeight: 600,
                        fontSize: 16,
                      }}
                    >
                      {totalBom}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div
            style={{ display: "flex", justifyContent: "center", marginTop: 35 }}
          >
            <Space>
              <Button
                onClick={() => {
                  setIsOpen(false);
                }}
                style={{
                  width: "200px",
                  height: "50px",
                  background: "#E76464",
                  borderRadius: 4,
                  color: "white",
                }}
              >
                ยกเลิก/Cancel
              </Button>

              <Button
                htmlType="submit"
                style={{
                  width: "200px",
                  height: "50px",
                  background: "#4D7E7F",
                  borderRadius: 4,
                  color: "white",
                }}
              >
                บันทึกข้อมูล/Submit
              </Button>
            </Space>
          </div>
        </Form>
      </div>
    </div>
  );
};
export default TreatmentCreate;
